export const listCodeBank = [
  { code: "001", name: "Banco do Brasil" },
  { code: "033", name: "Santander" },
  { code: "104", name: "Caixa Econômica" },
  { code: "237", name: "Bradesco" },
  { code: "237", name: "Next" },
  { code: "341", name: "Itaú" },
  { code: "041", name: "Banrisul" },
  { code: "748", name: "Sicredi" },
  { code: "756", name: "Sicoob" },
  { code: "077", name: "Inter" },
  { code: "070", name: "BRB" },
  { code: "085", name: "Via Credi" },
  { code: "655", name: "Neon/Votorantim" },
  { code: "260", name: "Nubank" },
  { code: "290", name: "Pagseguro" },
  { code: "212", name: "Banco Original" },
  { code: "422", name: "Safra" },
  { code: "746", name: "Modal" },
  { code: "021", name: "Banestes" },
  { code: "136", name: "Unicred" },
  { code: "274", name: "Money Plus" },
  { code: "389", name: "Mercantil do Brasil" },
  { code: "376", name: "JP Morgan" },
  { code: "364", name: "Gerencianet Pagamentos do Brasil" },
  { code: "336", name: "Banco C6" },
  { code: "218", name: "BS2" },
  { code: "082", name: "Banco Topazio" },
  { code: "099", name: "Uniprime" },
  { code: "197", name: "Stone" },
  { code: "707", name: "Banco Daycoval" },
  { code: "633", name: "Rendimento" },
  { code: "004", name: "Banco do Nordeste" },
  { code: "745", name: "Citibank" },
  { code: "301", name: "PJBank" },
  { code: "97", name: "Cooperativa Central de Credito Noroeste Brasileiro" },
  { code: "084", name: "Uniprime Norte do Paraná" },
  { code: "384", name: "Global SCM" },
  { code: "403", name: "Cora" },
  { code: "323", name: "Mercado Pago" },
  { code: "003", name: "Banco da Amazonia" },
  { code: "752", name: "BNP Paribas Brasil" },
  { code: "383", name: "Juno" },
  { code: "133", name: "Cresol" },
  { code: "173", name: "BRL Trust DTVM" },
  { code: "047", name: "Banco Banese" },
  { code: "208", name: "Banco BTG Pactual" },
  { code: "613", name: "Banco Omni" },
  { code: "332", name: "Acesso Soluções de Pagamento" },
  { code: "273", name: "CCR de São Miguel do Oeste" },
  { code: "093", name: "Polocred" },
  { code: "355", name: "Ótimo" },
  { code: "121", name: "Agibank" },
  { code: "037", name: "Banpará" },
  { code: "380", name: "Picpay" },
  { code: "125", name: "Banco Genial" },
  { code: "412", name: "Banco Capital S.A" },
  { code: "741", name: "Banco Ribeirão Preto" },
  { code: "461", name: "ASAAS IP" },
  { code: "623", name: "Banco Pan" },
  { code: "735", name: "Neon" },
  { code: "310", name: "VORTX DTVM LTDA" },
  { code: "318", name: "Banco BMG" },
  { code: "450", name: "Fitbank" },
  { code: "174", name: "Pefisa" },
  { code: "451", name: "J17 - SCD S/A" },
  { code: "089", name: "Credisan" },
];
